import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FEditIntroductionDrawer from './FEditIntroductionDrawer';

interface fEditIntroductionDrawerProps {
  text: string;
}

type ReturnData = string | null;

function fEditIntroductionDrawer({ text }: fEditIntroductionDrawerProps): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FEditIntroductionDrawer
        text={text}
        onConfirm={(text) => {
          resolve(text);
        }}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
      />,
    );
  });
}

export default fEditIntroductionDrawer;
